import script from "./EVReports.vue?vue&type=script&lang=ts&setup=true"
export * from "./EVReports.vue?vue&type=script&lang=ts&setup=true"

import "./EVReports.vue?vue&type=style&index=0&id=c4ba1340&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4ba1340"]])

export default __exports__